
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import ForCreatorsView from "@/views/for-creators"

function ForCreatorsPage() {
  return (
    <>
      <Head>
        <title>Dla Twórców | fansi.pl</title>
        <SEO description="Razem z fansi możesz łatwo tworzyć i sprzedawać produkty, które Twoi fani pokochają: e-booki, audiobooki, planery, tematyczne spotkania na żywo, krótkie video z życzeniami na zamówienie, presety i cyfrowe pędzle." />
      </Head>
      <ForCreatorsView />
    </>
  )
}

ForCreatorsPage.Layout = Default

export default ForCreatorsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/for-creators',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  